/**
 * Firebase App Check constants (Passport SPA).
 * Mirror: backend/src/config/appCheck.ts
 */

import {
  VITE_FIREBASE_APP_CHECK_DEBUG_TOKEN,
  VITE_FIREBASE_APP_CHECK_RECAPTCHA_SITE_KEY,
} from '../generated-env';

export const FIREBASE_APP_CHECK_RECAPTCHA_SITE_VITE_ENV = 'VITE_FIREBASE_APP_CHECK_RECAPTCHA_SITE_KEY' as const;

export const FIREBASE_APP_CHECK_DEBUG_TOKEN_VITE_ENV = 'VITE_FIREBASE_APP_CHECK_DEBUG_TOKEN' as const;

export const FIREBASE_APP_CHECK_ENFORCE_FUNCTIONS = true as const;

export const FIREBASE_APP_CHECK_ENFORCE_FIRESTORE = true as const;

export const FIREBASE_APP_CHECK_CSP_SCRIPT_ORIGINS = [
  'https://www.google.com',
  'https://www.gstatic.com',
] as const;

export const FIREBASE_APP_CHECK_CSP_CONNECT_ORIGINS = [
  'https://firebaseappcheck.googleapis.com',
  'https://content-firebaseappcheck.googleapis.com',
  'https://www.google.com',
  'https://www.gstatic.com',
] as const;

export const FIREBASE_APP_CHECK_CSP_FRAME_ORIGINS = [
  'https://www.google.com',
  'https://www.recaptcha.net',
] as const;

function str(v: unknown): string {
  return typeof v === 'string' ? v.trim() : '';
}

export function getFirebaseAppCheckRecaptchaSiteKey(): string {
  return str(VITE_FIREBASE_APP_CHECK_RECAPTCHA_SITE_KEY);
}

export function getFirebaseAppCheckDebugToken(): string {
  return str(VITE_FIREBASE_APP_CHECK_DEBUG_TOKEN);
}

export function isFirebaseAppCheckConfigured(): boolean {
  return getFirebaseAppCheckRecaptchaSiteKey().length > 0;
}
